module.exports = __webpack_public_path__ + "img/flow4.592614e2.png";